"use client";
import { jsx } from "react/jsx-runtime";
import { createElement, forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { Heading } from "../Heading/index.js";
import { popupHeaderVariants } from "./PopupHeader.variants.js";
import { usePopupHeaderContext } from "./PopupHeaderContext.js";
const PopupHeader_Title_PopupHeaderTitle = /*#__PURE__*/ forwardRef(function({ className, children, asTitle, ...props }, ref) {
    const { scrim } = usePopupHeaderContext();
    const { title } = popupHeaderVariants();
    const heading = /*#__PURE__*/ jsx(Heading, {
        as: "h2",
        ref: ref,
        className: cn(title(), scrim && 'text-neutral-1', className),
        ...props,
        children: children
    });
    if (asTitle) return /*#__PURE__*/ createElement(asTitle, {
        render: heading
    });
    return heading;
});
PopupHeader_Title_PopupHeaderTitle.displayName = 'PopupHeader.Title';
export { PopupHeader_Title_PopupHeaderTitle as PopupHeaderTitle };
